export const DELETE_BATCH = 'DELETE_BATCH';
export const DELETE_BATCH_SUCCESS = 'DELETE_BATCH_SUCCESS';
export const DELETE_BATCH_ERROR  = 'DELETE_BATCH_ERROR';

export const USERS_LIST = 'USER_LIST';
export const USERS_LIST_SUCCESS = 'USERS_LIST_SUCCESS';
export const USERS_LIST_ERROR = 'USERS_LIST_ERROR';

export const MESSAGES_LIST = 'MESSAGES_LIST';
export const MESSAGES_LIST_SUCCESS = 'MESSAGES_LIST_SUCCESS';
export const MESSAGES_LIST_ERROR = 'MESSAGES_LIST_ERROR';

export const ADD_MESSAGE = 'ADD_MESSAGE';
export const ADD_MESSAGE_SUCCESS = 'ADD_MESSAGE_SUCCESS';
export const ADD_MESSAGE_ERROR  = 'ADD_MESSAGE_ERROR';

export const EDIT_MESSAGE = 'EDIT_MESSAGE';
export const EDIT_MESSAGE_SUCCESS = 'EDIT_MESSAGE_SUCCESS';
export const EDIT_MESSAGE_ERROR = 'EDIT_MESSAGE_ERROR';

export const MESSAGE_DETAILS = 'MESSAGE_DETAILS';
export const MESSAGE_DETAILS_SUCCESS = 'MESSAGE_DETAILS_SUCCESS';
export const MESSAGE_DETAILS_ERROR = 'MESSAGE_DETAILS_ERROR';